import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface SalesStickyBarProps {
  label: string;
  hint: string;
  buttonLabel: string;
  href: string;
}
export function SalesStickyBar({
  label,
  hint,
  buttonLabel,
  href
}: SalesStickyBarProps) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const past = window.scrollY > window.innerHeight * 0.8;
      const nearEnd = window.scrollY + window.innerHeight > document.body.scrollHeight - window.innerHeight * 0.7;
      setVisible(past && !nearEnd);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-274" data-mp="3mnypdxbhs9gx">
      {visible && <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      duration: 0.35,
      ease: 'easeOut'
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-carbon/95 backdrop-blur-sm" data-id="element-275" data-mp="3ml46ia84mwpm">
          <div className="mx-auto flex max-w-4xl items-center justify-between gap-3 px-4 py-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))] sm:gap-4 sm:px-6" data-id="element-276" data-mp="2n3jpe24eifil">
            <div className="min-w-0" data-id="element-277" data-mp="2i3x9tm13on6m">
              <p className="truncate font-serif text-[14px] font-semibold text-ivory sm:text-[16px]" data-id="element-278" data-mp="2d5cbjs5esdkt">
                {label}
              </p>
              <p className="truncate font-mono text-[9.5px] tracking-[0.08em] text-gold-soft" data-id="element-279" data-mp="2857v224i3iul">
                {hint}
              </p>
            </div>
            <a href={href} className="group flex shrink-0 items-center gap-2 rounded-sm bg-gold px-3.5 py-3 font-mono text-[9.5px] font-bold uppercase tracking-[0.1em] text-[#181205] transition-colors duration-200 hover:bg-gold-soft focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-soft focus-visible:ring-offset-2 focus-visible:ring-offset-carbon sm:px-4 sm:text-[11px] sm:tracking-[0.14em]" data-id="element-280" data-mp="1z5kpr58nhsw9">
              {buttonLabel}
              <ArrowRight aria-hidden="true" className="h-3.5 w-3.5 transition-transform duration-200 group-hover:translate-x-0.5" data-id="element-281" data-mp="lbnpk25u48o8" />
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}